import React from 'react';
import { toFlag } from 'pano-utils';
import { useStore } from 'effector-react';
import type { Draft } from 'immer';
import type { STImage, STMatrix } from '@types';
import { $stImageSettingPanelApi } from '@stores/sandTableStores';
import { Collapse } from '@components/Collapse';
import FeatureToggle from '@components/FeatureToggle';
import Tip from '@components/Tip';
import { $curSandTable, $tourDataApi } from '@stores/dataStores';
import useTourEditing from '@hooks/useTourEditing';
import PanelBase from '../../panel/PanelBase';

export function PanelSandTableImageSetting() {
  const data = useStore($curSandTable) as STImage | STMatrix;
  const { state, setState, isChanged } = useTourEditing(data);
  const { showCompass, showCurrentSceneOnly } = state;

  const handleConfirm = () => {
    $tourDataApi.updateSandtable({
      id: data.id,
      updater: (draft: Draft<STImage | STMatrix>) => {
        draft.showCompass = showCompass;
        draft.showCurrentSceneOnly = showCurrentSceneOnly;
      },
    });
  };

  return (
    <PanelBase
      title="沙盘高级设置"
      isChanged={isChanged}
      onConfirm={handleConfirm}
      onRequestClose={$stImageSettingPanelApi.off}
    >
      <Collapse title="沙盘显示">
        <FeatureToggle
          title="显示指北针"
          isOn={!!showCompass}
          onToggle={(isOn) =>
            setState((draft) => {
              draft.showCompass = toFlag(isOn);
            })
          }
        />
        <FeatureToggle
          title="缩略图仅显示当前场景"
          isOn={!!showCurrentSceneOnly}
          onToggle={(isOn) => {
            setState((draft) => {
              draft.showCurrentSceneOnly = toFlag(isOn);
            });
          }}
        />
        <Tip className="mt-10">
          在场景沙盘缩略图中，只显示当前场景的标记点，以突出重点。
        </Tip>
      </Collapse>
    </PanelBase>
  );
}
